export default __webpack_public_path__ + "static/summer-sale-2025-subbanner-mobile-7359861b0becca5435fa3562307a2003.webp";